import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { cookie } from '@/utils/util'
// eslint-disable-next-line camelcase
import enUS from './locale/en_US'
import zhCN from './locale/zh_CN'
// import axios from 'axios'

Vue.use(VueI18n)

const messages = {
  'en_US': enUS,
  'zh_CN': zhCN
}

// 默认语言
const defaultLanguage = cookie.get('language') || 'zh_CN'

const i18n = new VueI18n({
  locale: defaultLanguage,
  fallbackLocale: defaultLanguage,
  messages
})

export default i18n

// 已经import的语言
const loadedLanguages = [defaultLanguage]

// 使用已经缓存的语言设置
if (cookie.get('language') && defaultLanguage !== cookie.get('language')) {
  loadLanguageAsync(cookie.get('language'))
}

function setI18nLanguage (lang) {
  i18n.locale = lang
  // axios.defaults.headers.common['Accept-Language'] = lang
  document.querySelector('html').setAttribute('lang', lang)
  // 设置国际化网页标题
  document.title = window.$globalHub.$t('htmlTit')
  return lang
}

export function loadLanguageAsync (lang = defaultLanguage) {
  // console.log(lang)
  return new Promise(resolve => {
    // 缓存语言设置
    Vue.prototype.$cookies.set('language', lang, 7 * 24 * 60 * 60)
    if (i18n.locale !== lang) {
      if (!loadedLanguages.includes(lang)) {
        return import(/* webpackChunkName: "lang-[request]" */ `./locale/${lang}`).then(msgs => {
          i18n.setLocaleMessage(lang, msgs.default)
          loadedLanguages.push(lang)
          return setI18nLanguage(lang)
        })
      }
      return resolve(setI18nLanguage(lang))
    }
    return resolve(lang)
  })
}
